import axios from 'axios'
import React, { Component } from 'react'
import { APIURL } from '../../hoc/AxiosSetting/axios'
import S3FileUpload from 'react-s3';
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance';


export default class Reports extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filenameToview: "",
            data: {},
            listOfCompanies: {
                orgCode: 0,
                masterAgreementUrl: ""
            },
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedMasterAgreementURL: "",
            submitStatus: true,
            messageforvalidation: "none",
            reporttype : "none",
            reporttype1:"none",
            sur:"",
            matrix:"",
            surdata:{},
            loginUserName : localStorage.getItem("fullName"),
            loginUserCode : localStorage.getItem("userCode"),
            loginUserRole : localStorage.getItem("userRole"),
            loginUserEmails: localStorage.getItem("emails")

        }

        this.masteragreementUrlInput = React.createRef();
    }
    handleChange = name => e => {
        var errorVar = e.target.name + "Error";
        const listOfCompaniesData = this.state.listOfCompanies;
        listOfCompaniesData[e.target.name] = e.target.value;
       
        if(e.target.value === 'auditmatrixreport'){
            this.setState({reporttype : "block" })
        }
        else if(e.target.value ==="auditobservationreport")
        {
            this.setState({reporttype : "none" })
        }
        if(e.target.value === 'auditobservationreport'){
            this.setState({reporttype1 : "block" })
        }
        else if(e.target.value ==="auditmatrixreport")
        {
            this.setState({reporttype1 : "none" })
        }
        if(e.target.value ==="Surveillance2")
        {
            this.setState({sur:"Sureillance 2"})
        }
        else {
            this.setState({sur:"Surveillance 1"})
        }
        if(e.target.value === "Planning"){
            this.setState({matrix:"Planning"})
        }else{
            this.setState({matrix:"Excecution"})
        }
        this.setState({
            listOfCompanies: listOfCompaniesData,
            [`${errorVar}`]: "", orgcode: e.target.value,
        })
    };
    componentDidMount() {       
        axios.get(APIURL + '/api/clientaccess/get/listofcompaniesreports/' + localStorage.getItem("userCode"))
            .then(res => {
                this.setState({ data: res.data.response })
                console.log("res.data.response",res.data.response)
            })
        axios.get(APIURL + '/api/survillanceTwo/get/surveillancetwodatawithoutcheckauth/' + this.state.listOfCompanies.orgCode)
            .then(res => {
                this.setState({ surdata: res.data.response })
                //console.log("surdata", res.data.response)
            })
    }

    downloadbothpdf = () =>{
        if(this.state.listOfCompanies.reporttype === "auditobservationreport"){
            this.downloadPDF();
        }
        else if(this.state.listOfCompanies.reporttype === "auditmatrixreport"){
          this.downloadPDF1();
      }
  
    }
    downloadPDF = () => {
  
        return axios.get(APIURL + '/api/generatepdf/get/surviellanceauditobservationpdf/' + this.state.listOfCompanies.orgCode+"/"+ this.state.sur, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `Audit Observation-${this.state.sur}.pdf`
                link.click()
            })

    }
    
    downloadPDF1 = () => {
    
        return axios.get(APIURL + '/api/generatepdf/get/auditplanmatrixpdf/' + this.state.listOfCompanies.orgCode+"/"+ this.state.matrix, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `Audit Matrix - ${this.state.matrix}.pdf`
                link.click()
            })

    }
    postData =()=>{
        alert("postdata")
        var jsonRequest = {
            orgCode :this.state.listOfCompanies.orgCode,
            // "orgName":this.state.listOfCompanies.orgName,
            // "typeOfCertification":this.state.listOfCompanies.typeOfCertification,
            "emailsentUserCode":this.state.loginUserCode,
            "emailsentUserName":this.state.loginUserName,
            "emailSentRole":this.state.loginUserRole,
            "emailSentEmailId":this.state.loginUserEmails
        }
        console.log("json ", jsonRequest)
        axios
            .post(APIURL + "/api/mail/post/emailsentforsurreport", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                   
                    ToastInstance('Success', 'Surveillance Report Updated')
                   // window.location.href = "/"+localStorage.getItem("role")+'/view/viewauditagreements/'+this.state.orgCode
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })
    }
    render() {
        const listOfCompaniess = this.state.data;
        let listOfCompaniesList = listOfCompaniess.length > 0 && listOfCompaniess.map((item, i) => {
            return (
                <option key={i} value={item.value}>{item.label}</option>
            )
        }, this)
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ minHeight: "450px" }}>
                                        <div className="row htmlpage">
                                            <div className="col-sm-12">
                                                <div className="row">
                                                    <label className="formSingleElementLabel">Organization Name</label>
                                                </div>
                                                <div className="form1Row">
                                                    <div className="col-sm-11">
                                                        <select className="formSingleElementField" onChange={this.handleChange("orgCode")} name="orgCode" value={this.state.listOfCompanies.orgCode}>
                                                            <option value="-">Select</option>
                                                            {listOfCompaniesList}
                                                        </select>

                                                    </div>
                                                </div>
                                                <div className="row" >
                                                    <label className="formSingleElementLabel">Report Type</label>
                                                    <div className="form1Row">
                                                        <div className="col-sm-11">
                                                        <select className="formSingleElementField" name="reporttype" onChange={this.handleChange("reporttype")} value={this.state.data.reporttype} >
                                                                    <option value="">Select</option>
                                                                    <option value="auditmatrixreport">Audit Matrix Report</option>
                                                                    <option value="auditobservationreport">Audit Observation Report</option>
                                                                    
                                                                </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-3" style={{display : this.state.reporttype}}>
                                                    <label className="formSingleElementLabel">Audit Matrix Type</label>
                                                    <div className="form1Row">
                                                        <div className="col-sm-11">
                                                        <select className="formSingleElementField" name="reporttype1" onChange={this.handleChange("reporttype1")} value={this.state.data.reporttype1} >
                                                                    <option value="">Select</option>
                                                                    <option value="Planning">Audit Matrix Planning</option>
                                                                    <option value="Excecution">Audit Matrix Execution</option>
                                                                </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-3" style={{display : this.state.reporttype1}}>
                                                    <label className="formSingleElementLabel">Audit observation type</label>
                                                    <div className="form1Row">
                                                        <div className="col-sm-11">
                                                        <select className="formSingleElementField" name="surveillanceType" onChange={this.handleChange("surveillanceType")} value={this.state.data.surveillanceType} >
                                                                    <option value="">Select</option>
                                                                    <option value="Sureillance1">Surveillance 1</option>
                                                                    <option value="Surveillance2">Surveillance 2</option>
                                                                </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            <div className="row mt-5">
                                                {/* <div className="col-sm-5">
                                                <button type="submit" className="btn btn-primary float-right" onClick={()=>{this.downloadPDF()}}>Download Observation Report</button>

                                                </div>
                                                <div className="col-sm-5">
                                                    <button type="submit" className="btn btn-primary float-right" onClick={()=>{this.downloadPDF1()}}>Download Matrix Report</button>
                                                </div> */}
                                                <div className="col-sm-7"></div>
                                                { 
                                                    localStorage.getItem("userRole") === "Lead Auditor" ?
                                                    <div className="col-sm-3">
                                                        <button type="submit" className="btn btn-primary float-right" onClick={()=>{this.postData()}}>Approved By</button>
                                                    </div>
                                                    :""
                                            }
                                                <div className="col-sm-2">
                                                    <button type="submit" className="btn btn-primary float-right" onClick={()=>{this.downloadbothpdf()}}>Download</button>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                      
                           
                    </section>

                </div>
            </div>
        )
    }
}